<div class="panel panel-white">
    <div class="panel-heading border-light">
        <h4 class="panel-title">Buildxact Onsite crew</h4>
        <button id="invite-bxo-crew" class="btn-bx-primary" (appSingleClick)="inviteContact()">
            <i class="fa-light fa-plus"></i> Invite crew
        </button>
    </div>
    <div class="panel-body">
        <div class="bx-base-table">
            <div class="bx-base-table-header bx-base-table-row bold">
                <div>Name</div>
                <div>Business name</div>
                <div>Email</div>
                <div>Status</div>
            </div>
            <div class="bx-base-table-body">
                @for (user of tenantUsers(); track $index) {
                    <div class="bx-base-table-row">
                        <div>
                            @let name = user.firstname + ' ' + user.surname;
                            <span class="ellipsis-generic" [matTooltip]="name">{{ name }}</span>
                        </div>
                        <div></div>
                        <div>
                            <span class="ellipsis-generic" [matTooltip]="user.email">{{ user.email }}</span>
                        </div>
                        <div>
                            <div class="chip round light-blue">Default</div>
                        </div>
                        <div>
                            <button class="remove-bxo-crew btn-flat square red action-delete" [disabled]="true">
                                <i class="fa-light fa-trash-can"></i>
                            </button>
                        </div>
                    </div>
                }
                @for (invite of invitations(); track invite.iD_JobInvitation) {
                    <div class="bx-base-table-row">
                        <div>
                            @let name = invite.inviteeFirstName + ' ' + invite.inviteeLastName;
                            <span class="ellipsis-generic" [matTooltip]="name">{{ name }}</span>
                        </div>
                        <div>
                            <span class="ellipsis-generic" [matTooltip]="invite.contact?.businessName">
                                {{ invite.contact?.businessName }}
                            </span>
                        </div>
                        <div>
                            <span class="ellipsis-generic" [matTooltip]="invite.email">{{ invite.email }}</span>
                        </div>
                        <div>
                            <div
                                class="chip round"
                                [ngClass]="{
                                    green: invite.status === inviteStatus.Accepted,
                                    red: invite.status === inviteStatus.Declined,
                                }">
                                {{ invite.status | titlecase }}
                            </div>
                        </div>
                        <div>
                            <button
                                class="remove-bxo-crew btn-flat square red action-delete"
                                (appSingleClick)="deleteJobInvitation(invite)">
                                <i class="fa-light fa-trash-can"></i>
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
